import { usePartnerIntegrationWidgetConfigurations } from '@dixa/lib-integrations-partner-widgets';
import { config } from 'lib-shared-backend-config';
import { useMemo } from 'react';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { usePartnerWidgetFeatureFlags } from 'utils/partnerIntegrationsWidget/usePartnerWidgetFeatureFlags';

import { partnerIntegrations } from '../../../../utils/useIntegrations/integrations';
import { IntegrationsCardItem } from '../../card/integrationsCard';

type UsePartnerWidgetRepsonse = {
  isLoading: boolean;
  partnerWidgets: IntegrationsCardItem[];
};

const emptyArray: IntegrationsCardItem[] = [];

/**
 * A hook that returns a list of partner widgets and checks if they are enabled
 * with feature-flags.
 */
export const usePartnerWidgets = (): UsePartnerWidgetRepsonse => {
  const partnerWidgetFeatureFlags = usePartnerWidgetFeatureFlags();
  const { partnerIntegrationsWidget: showAllPartnerIntegrations } =
    useFeatureFlag(['partner-integrations-widget']);

  const { isLoading, widgets } = usePartnerIntegrationWidgetConfigurations(
    config.url.partnerIntegrations,
  );

  const partnerWidgets: IntegrationsCardItem[] = useMemo(() => {
    if (showAllPartnerIntegrations && widgets?.length && !isLoading) {
      return widgets
        .filter(({ type }) => partnerWidgetFeatureFlags[type.toUpperCase()])
        .map(
          (widget) =>
            ({
              id: widget.id,
              integrationId: partnerIntegrations[widget.type].id,
              description: partnerIntegrations[widget.type].description,
              cardType: widget.type,
              integrationType: 'partnerWidget',
              label: widget.name,
              enabled: widget.enabled,
            } as IntegrationsCardItem),
        );
    }
    return emptyArray;
  }, [widgets, showAllPartnerIntegrations, partnerWidgetFeatureFlags]);

  return {
    isLoading,
    partnerWidgets,
  };
};
